const SCENES = {
  'Kitchens': [
    { num: 1, thumb: '/mainpng2.png',        label: 'Kitchen + Cabinet' },
    { num: 2, thumb: '/mainpng.png',          label: 'Island Layout' },
    { num: 3, thumb: '/mainpng3.png',         label: 'L-Shape Kitchen' },
  ],
  'Vanities': [
    { num: 1, thumb: '/mainvanitiespng.png',  label: 'Double Vanity' },
    { num: 2, thumb: '/mainvanitiespng1.png', label: 'Floating Sink' },
    { num: 3, thumb: '/mainvanitiespng2.png', label: 'Single Basin' },
  ],
  'Wall-cladding': [
    { num: 1, thumb: '/mainwallcladding.png',  label: 'Feature Wall 1' },
    { num: 2, thumb: '/mainwallcladding1.png', label: 'Feature Wall 2' },
    { num: 3, thumb: '/mainwallcladding2.png', label: 'Feature Wall 3' },
    { num: 4, thumb: '/mainwallcladding3.png', label: 'Feature Wall 4' },
  ],
};

const ScenePicker = ({ activeView, currentViewNum, onSelect }) => {
  const scenes = SCENES[activeView] || [];
  if (scenes.length <= 1) return null;

  return (
    <div className="scene-picker">
      {scenes.map((scene) => (
        <button
          key={scene.num}
          className={`scene-picker-thumb${currentViewNum === scene.num ? ' active' : ''}`}
          onClick={() => onSelect(scene.num)}
          aria-label={scene.label}
        >
          <img src={scene.thumb} alt={scene.label} />
          <span className="scene-picker-label">{scene.label}</span>
        </button>
      ))}
    </div>
  );
};

export default ScenePicker;
